import { FaCalendarAlt } from "react-icons/fa";
import BlogDetailsStyleWrapper from "./BlogDestails.style";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";

// components
import CommentBoxment from "../commentBox/CommentBox";
import avatarIcon from "../../../../assets/images/blog/user.png";

const BlogDetails = () => {
  return (
    <BlogDetailsStyleWrapper>
      <div className="blog_post_details_wrapper">
        <div className="post_thumbnail">
        </div>
        <div className="container">
          <div className="row">
            {/* post details col  */}
            <div className="blog_details">

              <div className="blog_post_meta">
                <a href="# " className="post_author">
                  <img src={avatarIcon} alt="blog post avatar" />
                  <span>By Admin</span>
                </a>
                <span>
                  {" "}
                  <FaCalendarAlt /> 30 JULY, 2024
                </span>
              </div>
              <h1 className="post_title">
                Bitcoin Takes on the Fed: Is a Historic Rally on the Horizon?
              </h1>
              <div className="blog_description">
                <p className="text-white">
                  The prices of cryptocurrency businesses’ shares rose sharply last month, while the index of stocks related to bitcoin mining saw a 77% increase in January. These changes portend a positive start to the year for the cryptocurrency sector.Bitcoin ATMs are arguably the oldest form of crypto on-ramping. In Bitcoin ATMs, cash is accepted and converted into Bitcoin; a new wallet is created at each transaction, allowing your newly purchased Bitcoin to be circulated on the blockchain.
                </p>
                <p>
                  The only time you do not need identification to access Bitcoin ATMs is when you are using an exchange. Bitcoin ATMs, however, do not seem likely to be the go-to solution due to the limitation on how much Bitcoin you can create each time, as well as the obvious problem of finding a machine.The other central banks have done the same in slightly lower proportions. As for governments, they have continued to accumulate even more public debt to support their respective economies.
                </p>
                <p>
                  This means that sale, transfer, and conversion of cryptocurrency coins may be held to the same standards as other securities and stocks, which the SEC oversees. This means that coin offerings must now be registered with the SEC, or else they could violate federal regulations.At the same time, it is unclear if this position of the SEC will be strictly enforced. The SEC stated that the “Distributed Anonymous Organization,” which held its coin offering in July, may have violated SEC regulations in doing so
                </p>
                <p>
                  We haven’t yet gotten to the point where Warren Buffett would have dubbed Bitcoin. Nevertheless, we are at the beginning of a journey of a thousand steps, to paraphrase Lao Tzu.Your account will be created once you have provided this information. You will be able to buy an array of coins and tokens using your debit or credit card, and your crypto will be sent to the platform’s custodial wallet, which was automatically created when you set up your account.
                </p>
                <p>
                  Bitcoin, the mother of all cryptocurrencies, has undergone a significant change in its fee structure due to the emergence of ordinals. In recent years, the “digital gold” has primarily been used as a store of value and an alternative asset class, offering portfolio diversification, protection against inflation, and the potential for long-term capital growth. Despite initiatives in countries like El Salvador, its use as a means of payment has somewhat taken a backseat. This has resulted in a stagnation of transaction fees, which at the beginning of the year were at similar levels to 2017.
                </p>
                <div className="blockquote">
                  <p>
                    On the other hand, we denounce with righteous indignation
                    and dislike men who are so beguiled and demoralized by the
                    charms of pleasure.
                  </p>
                </div>
                <div>
                  <h4>Play-to-Earn</h4>
                  <p>
                    Richard McClintock, a Latin professor at Hampden-Sydney
                    College There are many variations of passages of available,
                    but the majority have suffered alteration in some form.
                  </p>
                  <p>
                    Injected humour, or randomised words which don't look even
                    slightly believable. If you are going to use a passage of
                    Lorem Ipsum, you need to be sure there isn't anything
                    embarrassing.making it over 2000 years old.{" "}
                  </p>
                </div>
              </div>

              {/* related posts  */}
              <div className="related_posts_wrapper">
                <a href="# " className="related_post_item">
                  <FaLongArrowAltLeft /> <span>PREVIOUS</span>
                  <div className="related_post__title">
                    Eye-opening guide to product review scraping in 2024
                  </div>
                </a>
                <a href="# " className="related_post_item next">
                  <div className="related_post__title_first">
                    <span>Next</span> <FaLongArrowAltRight />
                  </div>
                  <div className="related_post__title">
                    Bitcoin Takes on the Fed: Is a Historic Rally on the Horizon?
                  </div>
                </a>
              </div>

              {/* comment box */}
              <CommentBoxment />
            </div>
          </div>
        </div>
      </div>
    </BlogDetailsStyleWrapper>
  );
};

export default BlogDetails;
